/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V3Advertiser } from '../models/V3Advertiser';
import { HttpFile } from '../http/http';

export class V3ListAdvertisersResponse {
    /**
    * the advertisers found in the current page.
    */
    'advertisers'?: Array<V3Advertiser>;
    /**
    * the page token to send to retrieve the next page of results.
    */
    'nextPageToken'?: string;
    /**
    * the total number of results without regard to page .
    */
    'totalSize'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "advertisers",
            "baseName": "advertisers",
            "type": "Array<V3Advertiser>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "next_page_token",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalSize",
            "baseName": "total_size",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return V3ListAdvertisersResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

